import ButtonWithIcon from "@/components/common/button-with-icon";
import downloadIcon from "@/assets/icons/download-icon-active.svg";
import downloadDisabledIcon from "@/assets/icons/download-icon.svg";
import { CommandButtonProps } from "@/components/common/command-buttons/data/command-button.data";

const DownloadButton = ({
  isEnabled,
  handleClick,
  hideText,
}: CommandButtonProps) => {
  return (
    <ButtonWithIcon
      isEnabled={isEnabled}
      handleClick={handleClick}
      text={hideText ? undefined : "Download"}
      iconPath={downloadIcon}
      disabledIconPath={downloadDisabledIcon}
      tooltip="Download"
    />
  );
};

export default DownloadButton;
